import type { DataOption, GroupBase, OptionsOrGroups } from './types'

import { flatten } from 'lodash/fp'

export const isGroup = (
	option: DataOption | GroupBase<DataOption>
): option is GroupBase<DataOption> => 'options' in option
export const isGrouped = (
	options: OptionsOrGroups<DataOption, GroupBase<DataOption>>
) => options.some(isGroup)
export const isDataOption = (
	option: DataOption | GroupBase<DataOption>
): option is DataOption => !('options' in option)

export const gatFlatOptions = <TOption extends DataOption>(
	options: OptionsOrGroups<TOption, GroupBase<TOption>>
) =>
	flatten(
		options?.map((v) => {
			if ((v as GroupBase<TOption>).options) {
				return (v as GroupBase<TOption>).options
			} else {
				return [v] as TOption[]
			}
		})
	)
